import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { InsurancePlanDto } from '../dto/insurance/insurance-plan.dto';
import { BaseServiceClient } from './base-service-client';

@Injectable({
    providedIn: 'root',
})
export class InsurancesClientService extends BaseServiceClient {
    private readonly InsurancePlanBaseUrl = `${this.ApiBaseUrl}${this.appConstants.httpClient.mcaBase}/insurances`;

    public getInsurancePlans(): Observable<InsurancePlanDto[]> {
        return this.get<InsurancePlanDto[]>(`${this.InsurancePlanBaseUrl}/plans`);
    }
}
